import { useLottie } from 'lottie-react'
import { CSSProperties } from 'styled-components'
import animationData from '~/assets/lottie/spotswap-form-skeleton.json'

interface SkeletonProps {
  style?: CSSProperties
}

const Skeleton: React.FC<SkeletonProps> = ({ style = {} }: SkeletonProps) => {
  const composedStyle = {
    width: 104,
    height: 20,
    ...style,
  }
  const options = {
    animationData,
    loop: true,
    autoplay: true,
  }
  const { View } = useLottie(options, composedStyle)
  return View
}

export default Skeleton
